import request from '@/util/request'
// import qs from 'qs'

// 查询更新日志
export function GetUpgradeLog() {
  return request({
    url: '/api/Temporary/GetUpgradeLog',
    method: 'get',
    params: { }
  })
}
